module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "v-dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-toolbar', {
    staticClass: "pink"
  }, [_c('v-btn', {
    attrs: {
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.data.name))])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Associazione")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Tipo di socio")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.data.type))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showStatus = true
      }
    }
  }, [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Stato")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.translate(_vm.data.status)))])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.data.accepted !== '') ? _c('span', [_vm._v(_vm._s(_vm.message.accepted) + " " + _vm._s(_vm.data.accepted))]) : _c('span', [_vm._v(_vm._s(_vm.message.submitted))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Richiesta il " + _vm._s(_vm.data.requested))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Pagamenti")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("payment")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Quota associativa " + _vm._s(_vm.currentYear))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.paidCurrentFee))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPayments = true
      }
    }
  }, [_vm._v("add_circle")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Contatti personali")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.mobile))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Mobile")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.email))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Personal")])], 1), _vm._v(" "), _c('v-list-tile-action')], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.street))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.data.city) + ", " + _vm._s(_vm.data.postal))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Anagrafica")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("person_outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.cf))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.data.birthday) + ", " + _vm._s(_vm.data.birthcity))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.error.show = $$v
      },
      expression: "error.show"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.error.message) + "\n  "), _c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.error.show = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.removeConfirmation),
      callback: function($$v) {
        _vm.removeConfirmation = $$v
      },
      expression: "removeConfirmation"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-card-title', [_vm._v("Remove staff member?")])], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeConfirmation = false
      }
    }
  }, [_vm._v("Disagree")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    nativeOn: {
      "click": function($event) {
        _vm.removeStaff($event)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showPayments),
      callback: function($$v) {
        _vm.showPayments = $$v
      },
      expression: "showPayments"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-card-title', [_c('strong', [_vm._v("Add payment")])])], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Anno (quota associativa)"
    },
    model: {
      value: (_vm.pay.fee),
      callback: function($$v) {
        _vm.pay.fee = $$v
      },
      expression: "pay.fee"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Data (gg/mm/aaaa)"
    },
    model: {
      value: (_vm.pay.date),
      callback: function($$v) {
        _vm.pay.date = $$v
      },
      expression: "pay.date"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Euro"
    },
    model: {
      value: (_vm.pay.amount),
      callback: function($$v) {
        _vm.pay.amount = $$v
      },
      expression: "pay.amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', _vm._l((_vm.data.payments), function(payment, paymentFee) {
    return _c('div', [_c('strong', [_vm._v(_vm._s(paymentFee))]), _vm._v("   " + _vm._s(payment.date) + "   " + _vm._s(payment.amount) + " €\n        ")])
  }))], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showPayments = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    nativeOn: {
      "click": function($event) {
        _vm.addPayment($event)
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showStatus),
      callback: function($$v) {
        _vm.showStatus = $$v
      },
      expression: "showStatus"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-card-title', [_c('strong', [_vm._v("Change status")])])], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Active",
      "primary": "",
      "value": "active",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Accepted",
      "primary": "",
      "value": "accepted",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), (_vm.data.status === 'accepted') ? _c('v-text-field', {
    attrs: {
      "label": "Ammissione il (gg/mm/aaaa)"
    },
    model: {
      value: (_vm.data.accepted),
      callback: function($$v) {
        _vm.data.accepted = $$v
      },
      expression: "data.accepted"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.status === 'accepted') ? _c('v-text-field', {
    attrs: {
      "label": "Richiesta il (gg/mm/aaaa)"
    },
    model: {
      value: (_vm.data.requested),
      callback: function($$v) {
        _vm.data.requested = $$v
      },
      expression: "data.requested"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Inactive",
      "primary": "",
      "value": "inactive",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Submitted",
      "primary": "",
      "value": "submitted",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Incomplete",
      "primary": "",
      "value": "incomplete",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showStatus = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    nativeOn: {
      "click": function($event) {
        _vm.changeMemberStatus($event)
      }
    }
  }, [_vm._v("Change")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48f656e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MemberItem.vue
// module id = 121
// module chunks = 1